<template>
    <div class="email-selector">
        <div class="selected-emails" ref="selectedEmails" @click="focusInput">
            <div class="email" v-for="(email, index) in selectedEmails" :key="index">
                {{ email.nome }} - {{ email.email }}
                <button class="remove" @click="removeEmail(index)">x</button>
            </div>
            <input class="email-input" ref="emailInput" v-model="searchText" @input="search" @keydown.enter="selectEmail">
        </div>
        <ul class="email-list" v-show="showList">
            <li v-for="email in filteredEmails" :key="email" @click.prevent="addEmail(email)">

                <span>{{ email.nome }} - {{ email.email }} </span>
            </li>
            <li v-if="filteredEmails.length === 0" @click.prevent="showList = false">Nenhum item encontrado.</li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        contacts: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            emails: this.contacts,
            selectedEmails: [],
            searchText: '',
            showList: false
        }
    },
    watch: {
        contacts(newVal) {
            this.emails = newVal;
        },
        selectedEmails(newVal) {
            this.$emit('input', newVal);
        }
    },
    computed: {
        filteredEmails() {
                return this.emails.filter(email => this.selectedEmails.findIndex(item => item.email == email.email) == -1)
                    .filter(email => (email.nome ?? '').includes(this.searchText) || (email.email ?? '').includes(this.searchText))
        }
    },
    methods: {
        search() {
            this.showList = true
        },
        addEmail(email) {
            this.selectedEmails.push(email)
            this.searchText = ''
            this.showList = false
            this.$refs.emailInput.focus()
        },
        removeEmail(index) {
            this.selectedEmails.splice(index, 1)
            this.$refs.emailInput.focus()
        },
        selectEmail() {
            if (this.filteredEmails.length > 0) {
                this.addEmail(this.filteredEmails[0])
            }
        },
        focusInput() {
            this.$refs.emailInput.focus()
        }
    }
}
</script>

<style scoped>
.email-selector {
    position: relative;
    width: 100%;
}

.selected-emails {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 6px;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: text;
}

.email {
    display: inline-flex;
    align-items: center;
    margin-right: 8px;
    padding: 4px;
    background-color: #f2f2f2;
    border-radius: 4px;
}

.remove {
    margin-left: 4px;
    font-size: 12px;
    color: #666;
    cursor: pointer;
}

.email-input {
    flex: 1;
    margin-left: 4px;
    font-size: 16px;
    border: none;
    outline: none;
    background-color: transparent;
}

.email-list {
    position: absolute;
    z-index: 999;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: auto;
    cursor: pointer;
}

.email-list li {
    padding: 4px;
    border-bottom: 1px solid #ccc;
}

.email-list li:last-child {
    border-bottom: none;
}

.email-list li:hover {
    background-color: #f2f2f2;
}
</style>
